import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../context/LanguageContext';

const FeaturesSection = styled.section`
  padding: ${({ theme }) => theme.spacing.xxl} 0;
  background-color: ${({ theme }) => theme.colors.light};
`;

const FeaturesContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing.md};
`;

const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  position: relative;
  padding-bottom: ${({ theme }) => theme.spacing.md};
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 3px;
    background-color: ${({ theme }) => theme.colors.accent};
  }
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: ${({ theme }) => theme.spacing.xl};
`;

const FeatureCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.shadows.medium};
  padding: ${({ theme }) => theme.spacing.xl};
  text-align: center;
  transition: transform ${({ theme }) => theme.transitions.medium};
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const FeatureIcon = styled.div`
  font-size: 2.5rem;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const FeatureTitle = styled.h3`
  margin-bottom: ${({ theme }) => theme.spacing.md};
  font-size: 1.3rem;
`;

const FeatureDescription = styled.p`
  color: ${({ theme }) => theme.colors.textLight};
`;

const Features = () => {
  const { t } = useLanguage();
  
  // Définition des caractéristiques avec leurs icônes
  const featuresWithIcons = [
    {
      icon: 'bed',
      title: t('features.items.comfortable.title'),
      description: t('features.items.comfortable.description')
    },
    {
      icon: 'utensils',
      title: t('features.items.restaurant.title'),
      description: t('features.items.restaurant.description')
    },
    {
      icon: 'landmark',
      title: t('features.items.historic.title'),
      description: t('features.items.historic.description')
    },
    {
      icon: 'wifi',
      title: t('features.items.wifi.title'),
      description: t('features.items.wifi.description')
    },
    {
      icon: 'map-marker-alt',
      title: t('features.items.location.title'),
      description: t('features.items.location.description')
    },
    {
      icon: 'users',
      title: t('features.items.welcome.title'),
      description: t('features.items.welcome.description')
    }
  ];
  
  return (
    <FeaturesSection>
      <FeaturesContainer>
        <SectionTitle>{t('features.title')}</SectionTitle>
        <FeaturesGrid>
          {featuresWithIcons.map((feature, index) => (
            <FeatureCard key={index}>
              <FeatureIcon>
                <i className={`fas fa-${feature.icon}`}></i>
              </FeatureIcon>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </FeaturesGrid>
      </FeaturesContainer>
    </FeaturesSection>
  );
};

export default Features;
